import Switch from './Switch'
import matchRoute from './matchRoute'
import router from './router'


export {
  Switch,
  matchRoute,
  router,
}
